// src/hooks/useCurrentUser.js
import { useMemo } from 'react';
import { useUser } from '../context/UserContext';

/**
 * Hook reutilizable para obtener el usuario actual.
 * - Primero intenta desde UserContext
 * - Si no hay, hace fallback a localStorage (usuarioId, nombreUsuario)
 *
 * Devuelve:
 * - currentUser: { usuarioId, nombreUsuario } | null
 * - loading: boolean
 * - isAuthenticated: boolean
 */
export default function useCurrentUser() {
  const { user, loading } = useUser?.() ?? { user: null, loading: false };

  const storedUser = useMemo(() => {
    const usuarioId = localStorage.getItem('usuarioId');
    const nombreUsuario = localStorage.getItem('nombreUsuario');
    if (usuarioId) {
      return { usuarioId: Number(usuarioId), nombreUsuario: nombreUsuario || undefined };
    }
    return null;
  }, []);

  const currentUser = user ?? storedUser;
  const isAuthenticated = Boolean(currentUser?.usuarioId);

  return {
    currentUser,
    loading: Boolean(loading),
    isAuthenticated,
  };
}

// Helpers opcionales para persistir o limpiar el usuario en localStorage
// export function persistUser({ usuarioId, nombreUsuario }) {
//   localStorage.setItem('usuarioId', String(usuarioId));
//   if (nombreUsuario) localStorage.setItem('nombreUsuario', nombreUsuario);
// }
//
// export function clearPersistedUser() {
//   localStorage.removeItem('usuarioId');
//   localStorage.removeItem('nombreUsuario');
// }
